import { h } from '@atomify/jsx';
import { BPDFunctionalSvg } from '@atoms/svg/svg';
import { AreaSubscriptionSummaryData } from '@features/area-subscription/types';

export const AreaSubscriptionSummaryList = (data: AreaSubscriptionSummaryData) => {
    if (!data) return;
    return (
        <div class="u-margin-top-3 u-margin-bottom-3">
            <p class="u-body-normal-bold">{data.title}</p>
            <div class="u-margin-top-2 u-margin-left-1">
                {data.items.map((item) => (
                    <SummaryItem {...item} />
                ))}
            </div>

            {data.afterText && <p class="u-margin-top-2">{data.afterText}</p>}
        </div>
    );
};

const SummaryItem = (data: { value: string; positive: boolean }) => (
    <div class="u-flex u-margin-top-1">
        <span class={`u-color--${data.positive ? 'positive' : 'alert'}`}>
            <BPDFunctionalSvg name={`icons-${data.positive ? 'checkmark' : 'close'}`} />
        </span>
        <p class="u-margin-left-1">{data.value}</p>
    </div>
);

export const renderSummary = (data: AreaSubscriptionSummaryData) => (
    <AreaSubscriptionSummaryList {...data} />
);
